import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { BookingConfigService } from '../../services/booking-config.service';
import { formatTerminalLocationForDate } from '../../../models/BookingModel';

@Component({
  selector: 'pf-psf-info',
  imports: [TranslocoModule, DatePipe, CommonModule],
  templateUrl: './parkingshuttleflight-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parkingshuttleflight-info.component.scss',
})
export class ParkingShuttleFlightInfoComponent {
  @Input() type: 'departure' | 'arrival' = 'departure';
  @Input() psfCardInfo: any | undefined = {
    date: '',
    flightId: '',
    transferLocation: '',
    parkingTime: '',
    flightDate: '',
    hotel: false,
  };

  optionsConfig: any;

  day: string = '-';
  parkingTime: string = '';
  parkingDate: string = '';
  timeBeforeCheckin: any = '';
  dayNames = [
    'PARKIFLY.WEEKDAYS.SUNDAY',
    'PARKIFLY.WEEKDAYS.MONDAY',
    'PARKIFLY.WEEKDAYS.TUESDAY',
    'PARKIFLY.WEEKDAYS.WEDNESDAY',
    'PARKIFLY.WEEKDAYS.THURSDAY',
    'PARKIFLY.WEEKDAYS.FRIDAY',
    'PARKIFLY.WEEKDAYS.SATURDAY',
  ]
  showTooltip = false;
  showParkingTooltip = false;
  site: any;
  environment: any;

  constructor(private bookingConfigService: BookingConfigService) {
    this.site = this.bookingConfigService.getConfig().site;
    this.environment = this.bookingConfigService.getConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['psfCardInfo']?.currentValue?.date) {
      this.formatDate();
    }
    this.checkTerminalMaintenance();
  }

  ngOnInit(): void {
    if ('options' in this.environment) {
      const env: any = this.environment;
      if ('psfInfoCard' in env.options) {
        this.optionsConfig = env.options.psfInfoCard;
      }
    }
    if (this.psfCardInfo?.flightDate) {
      this.timeBeforeCheckin = Math.abs((new Date(this.psfCardInfo.flightDate).getTime()) - (new Date(this.psfCardInfo.date).getTime()));
      var days = Math.floor(this.timeBeforeCheckin / (24 * 60 * 60 * 1000))
      var hours = Math.floor((this.timeBeforeCheckin - days * 24 * 60 * 60 * 1000) / (60 * 60 * 1000));
      var minutes = Math.floor((this.timeBeforeCheckin - hours * 60 * 60 * 1000 - days * 24 * 60 * 60 * 1000) / (60 * 1000));
      this.timeBeforeCheckin = hours + (minutes ? ':' + minutes : '');
    }
    if (this.psfCardInfo?.date) {
      this.formatDate();
    }
    this.checkTerminalMaintenance();
    if (!this.psfCardInfo?.hotel && (this.site == 'quality' || this.site == 'aiden')) {
      this.showParkingTooltip = true;
    } else {
      this.showParkingTooltip = false;
    }
  }

  private checkTerminalMaintenance() {
    if (!this.psfCardInfo) return;
    if (this.psfCardInfo.transferLocation == 'Terminal 5') {
      this.psfCardInfo.transferLocation = 'Terminal 4';
      this.showTooltip = true;
    }
    const checkDate = this.psfCardInfo.transferDateTime || this.psfCardInfo.date || this.psfCardInfo.flightDate;
    if (this.psfCardInfo.transferLocation) {
      this.psfCardInfo.transferLocation = formatTerminalLocationForDate(this.psfCardInfo.transferLocation, checkDate);
    }
  }


  private formatDate() {
    var date = new Date(this.psfCardInfo.date),
      month = '' + (date.getMonth() + 1),
      day = '' + date.getDate(),
      year = date.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    this.parkingTime =
      (date.getHours().toString().length <= 1 ? '0' + date.getHours() : date.getHours()) + ':' +
      (date.getMinutes().toString().length <= 1 ? '0' + date.getMinutes() : date.getMinutes());

    this.day = this.dayNames[date.getDay()];
    this.parkingDate = [year, month, day].join('-');
  }

  get transferWeekdayKey(): string | null {
    const value = this.psfCardInfo?.transferDateTime;
    if (!value) return null;

    const date = new Date(value);
    const dayIndex = date.getDay();

    return this.dayNames[dayIndex];
  }

}